import React, { Component } from 'react';
import axios from 'axios';
import { ProductCarousel } from '../../../../../Shared/Content/Layouts/Widgets/ProductCarousel/ProductCarousel';
import { getTopPersonalizationInfo } from '../../../../../../../util/getTopPersonalizationInfo';

export class HorizontalRecommendation extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      zone: '',
      rec_attributes: [],
      target_header_txt: '',
      priceNumber: '',
    };

    this.setRecState = this.setRecState.bind(this);
    this.forceRerender = this.forceRerender.bind(this);
    this.forceRenderRecentlyViewed = this.forceRenderRecentlyViewed.bind(this);
    this.forceRenderSolrData = this.forceRenderSolrData.bind(this);
    this.mapArrayToObject = this.mapArrayToObject.bind(this);
    this.showRecs = this.showRecs.bind(this);
    this.removeRecentlyViewedProduct = this.removeRecentlyViewedProduct.bind(this);
  }

  setRecState(
    rec_product_ids,
    zone,
    symbolic,
    target_id,
    target_category,
    rec_attributes,
    target_attributes,
    target_header_txt,
    ab_test_id,
    rec_category_ids
  ) {
    if (!this.state.didUnmount) {
      if (rec_attributes && rec_attributes.length > 0) {
        this.setState({
          zone: zone,
          rec_attributes: this.mapArrayToObject(rec_attributes),
          target_header_txt: target_header_txt,
        });
      } else {
        this.setState({
          zone: '',
          rec_attributes: [],
          target_header_txt: '',
        });
      }
      this.props.getRecAttributes((this.state.rec_attributes || []).length);
    }
  }

  //Leaving below method here for local testing purposes
  setOptiRecs(zone) {
    if (zone === 'JFYZ1') {
      window.optiSmartRecs = [
        {
          widget: 'JFYZ1',
          alias: '',
          position: 'homeWidget',
          recs: [
            {
              prices: {
                USD: {
                  unitPrice: 89.5,
                  salePrice: 89.5,
                },
              },
              url: 'https://www.dillards.com/p/cremieux-blue-label-soho-tailored-fit-5-pocket-sateen-stretch-pants/516597729',
              img: 'https://dimg.dillards.com/is/image/DillardsZoom/mainProduct/cremieux-blue-label-soho-tailored-fit-5-pocket-sateen-stretch-pants/00000000_zi_d19029ee-d276-4ee0-9161-37cbaf44a666.jpg',
              attributes: {
                review_number: '4.77000',
                not_contains_girls: 'true',
                term: 'trouser',
                reviewrating: '35',
                decade: '054x',
                century: '05xx',
                new_arrival: 'false',
                dept: '0547',
                brand: 'cremieux',
                pricerange: 'average',
                primary_category: 'men',
                can_ship_international: 'true',
                discount: null,
                product_class: '343',
                on_sale: 'false',
              },
              id: 296251158352,
              title: 'Cremieux Blue Label CMX 5-Pocket Tailored-Fit Sateen Stretch Pants',
              refCode: '20375397',
            },
            {
              prices: {
                USD: {
                  unitPrice: 115,
                  salePrice: 115,
                },
              },
              url: 'https://www.dillards.com/p/daniel-cremieux-signature-label-stretch-flat-front-travel-pants/518663733',
              img: 'https://dimg.dillards.com/is/image/DillardsZoom/mainProduct/daniel-cremieux-signature-label-stretch-flat-front-travel-pants/00000000_zi_14a30cfe-be2a-417c-bc99-6dc13e8052b2.jpg',
              attributes: {
                review_number: '0.0',
                not_contains_girls: 'true',
                term: 'trouser',
                reviewrating: '0',
                decade: '054x',
                century: '05xx',
                new_arrival: 'true',
                dept: '0547',
                brand: 'cremieux',
                pricerange: 'expensive',
                primary_category: 'men',
                can_ship_international: 'true',
                discount: null,
                product_class: '344',
                on_sale: 'false',
              },
              id: 296251158402,
              title: 'Daniel Cremieux Signature Label Stretch Flat Front Travel Pants',
              refCode: '20497374',
            },
            {
              prices: {
                USD: {
                  unitPrice: 115,
                  salePrice: 115,
                },
              },
              url: 'https://www.dillards.com/p/polo-ralph-lauren-straight-fit-flat-front-stretch-twill-chino-pants/507303505',
              img: 'https://dimg.dillards.com/is/image/DillardsZoom/mainProduct/polo-ralph-lauren-straight-fit-flat-front-stretch-twill-chino-pants/00000001_zi_2f71e973-80f9-492e-af9b-11a59b63eda7.jpg',
              attributes: {
                review_number: '4.57000',
                not_contains_girls: 'true',
                term: 'polo shirt',
                reviewrating: '355',
                decade: '054x',
                century: '05xx',
                new_arrival: 'false',
                dept: '0545',
                brand: 'polo ralph lauren',
                pricerange: 'expensive',
                primary_category: 'men',
                can_ship_international: 'true',
                discount: null,
                product_class: '340|340',
                on_sale: 'false',
              },
              id: 296251158452,
              title: 'Polo Ralph Lauren Straight Fit Flat Front Stretch Twill Chino Pants',
              refCode: '05099682',
            },
            {
              prices: {
                USD: {
                  unitPrice: 45,
                  salePrice: 45,
                },
              },
              url: 'https://www.dillards.com/p/roundtree--yorke-travelsmart-corecomfort-straight-flat-front-straight-fit-chino-pant/509640717',
              img: 'https://dimg.dillards.com/is/image/DillardsZoom/mainProduct/roundtree--yorke-travelsmart-corecomfort-straight-flat-front-straight-fit-chino-pant/00000002_zi_khaki05814809.jpg',
              attributes: {
                review_number: '4.71000',
                not_contains_girls: 'true',
                term: 'trouser',
                reviewrating: '353',
                decade: '056x',
                century: '05xx',
                new_arrival: 'false',
                dept: '0562',
                brand: 'roundtree & yorke',
                pricerange: 'cheap',
                primary_category: 'men',
                can_ship_international: 'true',
                discount: null,
                product_class: '4ca',
                on_sale: 'false',
              },
              id: 296251158502,
              title:
                'Roundtree  Yorke TravelSmart Ultimate Performance Classic Straight Fit Flat Front Non-Iron Chino Pants',
              refCode: '05814809',
            },
            {
              prices: {
                USD: {
                  unitPrice: 45,
                  salePrice: 45,
                },
              },
              url: 'https://www.dillards.com/p/roundtree--yorke-travelsmart-corecomfort-flat-front-classic-relaxed-fit-chino-pants/509640715',
              img: 'https://dimg.dillards.com/is/image/DillardsZoom/mainProduct/roundtree--yorke-travelsmart-corecomfort-flat-front-classic-relaxed-fit-chino-pants/00000003_zi_dark_navy05814782.jpg',
              attributes: {
                review_number: '4.74000',
                not_contains_girls: 'true',
                term: 'trouser',
                reviewrating: '479',
                decade: '056x',
                century: '05xx',
                new_arrival: 'false',
                dept: '0562',
                brand: 'roundtree & yorke',
                pricerange: 'cheap',
                primary_category: 'men',
                can_ship_international: 'true',
                discount: null,
                product_class: '4ca',
                on_sale: 'false',
              },
              id: 296251158552,
              title: 'Roundtree  Yorke TravelSmart Ultimate Performance Classic Fit Flat Front Non-Iron Chino Pants',
              refCode: '05814782',
            },
            {
              prices: {
                USD: {
                  unitPrice: 45,
                  salePrice: 45,
                },
              },
              url: 'https://www.dillards.com/p/roundtree--yorke-travelsmart-corecomfort-5-pocket-slim-fit-chino-pants/515870267',
              img: 'https://dimg.dillards.com/is/image/DillardsZoom/mainProduct/roundtree--yorke-travelsmart-corecomfort-5-pocket-slim-fit-chino-pants/00000001_zi_d70377d0-0afd-453f-9efd-4cb20c26a94f.jpg',
              attributes: {
                review_number: '4.87000',
                not_contains_girls: 'true',
                term: 'trouser',
                reviewrating: '15',
                decade: '056x',
                century: '05xx',
                new_arrival: 'false',
                dept: '0562',
                brand: 'roundtree & yorke',
                pricerange: 'cheap',
                primary_category: 'men',
                can_ship_international: 'true',
                discount: null,
                product_class: '4ca',
                on_sale: 'false',
              },
              id: 296251158602,
              title: 'Roundtree  Yorke TravelSmart Ultimate Performance Slim Fit Flat Front Non-Iron Chino Pants',
              refCode: '20339834',
            },
            {
              prices: {
                USD: {
                  unitPrice: 60,
                  salePrice: 60,
                },
              },
              url: 'https://www.dillards.com/p/the-north-face-core-jogger-pants/518590232',
              img: 'https://dimg.dillards.com/is/image/DillardsZoom/mainProduct/the-north-face-core-jogger-pants/00000000_zi_63b16aa6-2c0f-4077-851c-bd70c576d846.jpg',
              attributes: {
                review_number: '4.79000',
                not_contains_girls: 'true',
                term: 'jogger',
                reviewrating: '136',
                decade: '057x',
                century: '05xx',
                new_arrival: 'true',
                dept: '0579',
                brand: 'the north face',
                pricerange: 'average',
                primary_category: 'men',
                can_ship_international: 'true',
                discount: null,
                product_class: '341',
                on_sale: 'false',
              },
              id: 296251158652,
              title: 'The North Face Core Jogger Pants',
              refCode: '20491985',
            },
            {
              prices: {
                USD: {
                  unitPrice: 60,
                  salePrice: 60,
                },
              },
              url: 'https://www.dillards.com/p/quiksilver-union-straight-fit-stretch-chino-pants/518714226',
              img: 'https://dimg.dillards.com/is/image/DillardsZoom/mainProduct/quiksilver-union-straight-fit-stretch-chino-pants/00000000_zi_91938d12-e3bf-4820-90d8-c5fabd47a6e5.jpg',
              attributes: {
                review_number: '0.0',
                not_contains_girls: 'true',
                term: 'trouser',
                reviewrating: '0',
                decade: '058x',
                century: '05xx',
                new_arrival: 'true',
                dept: '0586',
                brand: 'quiksilver',
                pricerange: 'average',
                primary_category: 'men',
                can_ship_international: 'true',
                discount: null,
                product_class: '466',
                on_sale: 'false',
              },
              id: 296251158702,
              title: 'Quiksilver Union Straight Fit Stretch Chino Pants',
              refCode: '20499607',
            },
            {
              prices: {
                USD: {
                  unitPrice: 100,
                  salePrice: 100,
                },
              },
              url: 'https://www.dillards.com/p/marmot-performance-stretch-topanga-pants/518645332',
              img: 'https://dimg.dillards.com/is/image/DillardsZoom/mainProduct/marmot-performance-stretch-topanga-pants/00000000_zi_5fb464f0-9815-49ea-907e-c449d313bfb6.jpg',
              attributes: {
                review_number: '0.0',
                not_contains_girls: 'true',
                term: 'trouser',
                reviewrating: '0',
                decade: '057x',
                century: '05xx',
                new_arrival: 'true',
                dept: '0574',
                brand: 'marmot',
                pricerange: 'average',
                primary_category: 'men',
                can_ship_international: 'true',
                discount: null,
                product_class: '345',
                on_sale: 'false',
              },
              id: 296251158752,
              title: 'Marmot Performance Stretch Topanga Pants',
              refCode: '20496168',
            },
            {
              prices: {
                USD: {
                  unitPrice: 125,
                  salePrice: 125,
                },
              },
              url: 'https://www.dillards.com/p/marmot-performance-stretch-scree-pants/518645293',
              img: 'https://dimg.dillards.com/is/image/DillardsZoom/mainProduct/marmot-performance-stretch-scree-pants/00000000_zi_a32e4fb3-a23e-42f6-8d36-dc10dcbc9395.jpg',
              attributes: {
                review_number: '0.0',
                not_contains_girls: 'true',
                term: 'trouser',
                reviewrating: '0',
                decade: '057x',
                century: '05xx',
                new_arrival: 'true',
                dept: '0574',
                brand: 'marmot',
                pricerange: 'expensive',
                primary_category: 'men',
                can_ship_international: 'true',
                discount: null,
                product_class: '345',
                on_sale: 'false',
              },
              id: 296251158802,
              title: 'Marmot Performance Stretch Scree Pants',
              refCode: '20496154',
            },
            {
              prices: {
                USD: {
                  unitPrice: 115,
                  salePrice: 115,
                },
              },
              url: 'https://www.dillards.com/p/polo-ralph-lauren-classic-fit-flat-front-stretch-chino-pants/518680754',
              img: 'https://dimg.dillards.com/is/image/DillardsZoom/mainProduct/polo-ralph-lauren-classic-fit-flat-front-stretch-chino-pants/00000000_zi_3467616a-1201-4916-af38-43a689128ea0.jpg',
              attributes: {
                review_number: '0.0',
                not_contains_girls: 'true',
                term: 'polo shirt',
                reviewrating: '0',
                decade: '054x',
                century: '05xx',
                new_arrival: 'true',
                dept: '0545',
                brand: 'polo ralph lauren',
                pricerange: 'expensive',
                primary_category: 'men',
                can_ship_international: 'true',
                discount: null,
                product_class: '340',
                on_sale: 'false',
              },
              id: 296251158852,
              title: 'Polo Ralph Lauren Classic Fit Flat-Front Stretch Chino Pants',
              refCode: '20498306',
            },
            {
              prices: {
                USD: {
                  unitPrice: 74.95,
                  salePrice: 74.95,
                },
              },
              url: 'https://www.dillards.com/p/rip-curl-classic-surf-corduroy-pants/518482301',
              img: 'https://dimg.dillards.com/is/image/DillardsZoom/mainProduct/rip-curl-classic-surf-corduroy-pants/00000000_zi_cbca84af-3917-40c0-85f1-f1f9a9523f39.jpg',
              attributes: {
                review_number: '0.0',
                not_contains_girls: 'true',
                term: 'cord',
                reviewrating: '0',
                decade: '058x',
                century: '05xx',
                new_arrival: 'false',
                dept: '0586',
                brand: 'rip curl',
                pricerange: 'average',
                primary_category: 'men',
                can_ship_international: 'true',
                discount: null,
                product_class: '400',
                on_sale: 'false',
              },
              id: 296251158902,
              title: 'Rip Curl Classic Surf Corduroy Pants',
              refCode: '20461146',
            },
            {
              prices: {
                USD: {
                  unitPrice: 79.5,
                  salePrice: 79.5,
                },
              },
              url: 'https://www.dillards.com/p/flag-and-anthem-madeflex-performance-straight-leg-5-pocket-pants/518661829',
              img: 'https://dimg.dillards.com/is/image/DillardsZoom/mainProduct/flag-and-anthem-madeflex-performance-straight-leg-5-pocket-pants/00000000_zi_55bcdaf7-de28-4983-b811-bf1c5316991b.jpg',
              attributes: {
                review_number: '0.0',
                not_contains_girls: 'true',
                term: 'trouser',
                reviewrating: '0',
                decade: '058x',
                century: '05xx',
                new_arrival: 'true',
                dept: '0585',
                brand: 'flag and anthem',
                pricerange: 'average',
                primary_category: 'men',
                can_ship_international: 'true',
                discount: null,
                product_class: '410',
                on_sale: 'false',
              },
              id: 296251158952,
              title: 'Flag and Anthem MadeFlex Performance Straight Leg 5-Pocket Pants',
              refCode: '20491292',
            },
            {
              prices: {
                USD: {
                  unitPrice: 65,
                  salePrice: 65,
                },
              },
              url: 'https://www.dillards.com/p/salty-crew-flagship-straight-fit-chino-pants/518661848',
              img: 'https://dimg.dillards.com/is/image/DillardsZoom/mainProduct/salty-crew-flagship-straight-fit-chino-pants/00000000_zi_ae40ea75-cdfe-4df6-b9fe-74bfdc5434c4.jpg',
              attributes: {
                review_number: '0.0',
                not_contains_girls: 'true',
                term: 'trouser',
                reviewrating: '0',
                decade: '058x',
                century: '05xx',
                new_arrival: 'false',
                dept: '0586',
                brand: 'salty crew',
                pricerange: 'average',
                primary_category: 'men',
                can_ship_international: 'true',
                discount: null,
                product_class: '420',
                on_sale: 'false',
              },
              id: 296251159002,
              title: 'Salty Crew Flagship Straight Fit Chino Pants',
              refCode: '20467201',
            },
          ],
        },
      ];
    } else if (zone === 'SRPZ1') {
      window.optiSmartRecs = [
        {
          widget: 'SRPZ1',
          alias: '',
          position: 'searchWidget',
          recs: [
            {
              prices: {
                USD: {
                  unitPrice: 70,
                  salePrice: 70,
                },
              },
              url: 'https://www.dillards.com/p/free-people-fp-movement-hot-shot-onesie/512240745',
              img: 'https://dimg.dillards.com/is/image/DillardsZoom/mainProduct/free-people-fp-movement-hot-shot-onesie/00000000_zi_97ab8270-f20d-43bd-ac68-66e61b35b044.jpg',
              attributes: {
                review_number: '4.75000',
                contains_sleeveless: 'true',
                not_contains_girls: 'true',
                reviewrating: '394',
                decade: '018x',
                century: '01xx',
                new_arrival: 'false',
                dept: '0188',
                brand: 'free people',
                pricerange: 'average',
                primary_category: "women's clothing",
                can_ship_international: 'true',
                discount: null,
                product_class: 'qa5',
                on_sale: 'false',
              },
              id: 295863863752,
              title: 'Free People FP Movement Sleeveless Scoop Neck Ankle Length Patch Pocket Hot Shot Onesie',
              refCode: '20129919',
            },
            {
              prices: {
                USD: {
                  unitPrice: 135,
                  salePrice: 135,
                },
              },
              url: 'https://www.dillards.com/p/lauren-ralph-lauren-beach-club-solids-underwire-ruffle-surplice-one-piece-swimsuit/512434339',
              img: 'https://dimg.dillards.com/is/image/DillardsZoom/mainProduct/lauren-ralph-lauren-beach-club-solids-underwire-ruffle-surplice-one-piece-swimsuit/00000000_zi_57570510-baed-4a15-aeb3-27951e77f641.jpg',
              attributes: {
                review_number: '4.84000',
                not_contains_girls: 'true',
                term: 'swimsuit',
                reviewrating: '147',
                decade: '019x',
                century: '01xx',
                new_arrival: 'false',
                dept: '0198',
                brand: 'lauren ralph lauren',
                pricerange: 'expensive',
                primary_category: "women's clothing",
                can_ship_international: 'true',
                discount: null,
                product_class: 'zb4',
                on_sale: 'false',
              },
              id: 295863863802,
              title: 'Lauren Ralph Lauren Beach Club Solids Underwire Ruffle Surplice V-Neck One Piece Swimsuit',
              refCode: '20140426',
            },
            {
              prices: {
                USD: {
                  unitPrice: 45,
                  salePrice: 45,
                },
              },
              url: 'https://www.dillards.com/p/polo-ralph-lauren-classic-fit-assorted-crewneck-tees-3-pack/515917877',
              img: 'https://dimg.dillards.com/is/image/DillardsZoom/mainProduct/polo-ralph-lauren-classic-fit-assorted-crewneck-tees-3-pack/00000000_zi_5e6f0dba-037a-42cc-ab62-4fc5ef2ebc0a.jpg',
              attributes: {
                review_number: '4.38000',
                not_contains_girls: 'true',
                term: 'polo shirt',
                reviewrating: '29',
                decade: '052x',
                century: '05xx',
                new_arrival: 'false',
                dept: '0521',
                brand: 'polo ralph lauren',
                pricerange: 'cheap',
                primary_category: 'men',
                can_ship_international: 'true',
                discount: null,
                product_class: '252',
                on_sale: 'false',
              },
              id: 295863863852,
              title: 'Polo Ralph Lauren Classic Fit Assorted Crew Neck T-Shirt 3-Pack',
              refCode: '20343131',
            },
            {
              prices: {
                USD: {
                  unitPrice: 75,
                  salePrice: 75,
                },
              },
              url: 'https://www.dillards.com/p/kurt-geiger-london-micro-quilted-crossbody-bag/518138837',
              img: 'https://dimg.dillards.com/is/image/DillardsZoom/mainProduct/kurt-geiger-london-micro-quilted-crossbody-bag/00000000_zi_80ef22a8-9bc6-40de-9d80-6b991ad07b40.jpg',
              attributes: {
                review_number: '5.00000',
                not_contains_girls: 'true',
                term: 'bag',
                reviewrating: '4',
                decade: '027x',
                century: '02xx',
                new_arrival: 'false',
                dept: '0277',
                brand: 'kurt geiger london',
                pricerange: 'average',
                primary_category: 'handbags',
                can_ship_international: 'true',
                discount: null,
                product_class: 'w1b',
                on_sale: 'false',
              },
              id: 295863863902,
              title: 'Kurt Geiger London Micro Solid Quilted Crossbody Bag',
              refCode: '20461695',
            },
            {
              prices: {
                USD: {
                  unitPrice: 89.99,
                  salePrice: 89.99,
                },
              },
              url: 'https://www.dillards.com/p/gianni-bini-grayson-leather-footbed-platform-sandals/518021836',
              img: 'https://dimg.dillards.com/is/image/DillardsZoom/mainProduct/gianni-bini-grayson-leather-footbed-platform-sandals/00000001_zi_fec898b0-70d9-469a-8c15-c427e227ecfe.jpg',
              attributes: {
                review_number: '4.49000',
                not_contains_girls: 'true',
                term: 'sandal',
                reviewrating: '39',
                decade: '067x',
                century: '06xx',
                new_arrival: 'false',
                dept: '0670',
                brand: 'gianni bini',
                pricerange: 'average',
                primary_category: 'shoes',
                can_ship_international: 'true',
                discount: null,
                product_class: 'tvq',
                on_sale: 'false',
              },
              id: 295863863952,
              title: 'Gianni Bini Grayson Leather Footbed Platform Toe Loop Strappy Sandals',
              refCode: '20457552',
            },
            {
              prices: {
                USD: {
                  unitPrice: 110,
                  salePrice: 110,
                },
              },
              url: 'https://www.dillards.com/p/birkenstock-womens-arizona-patent-birko-flor-slide-sandals/518092283',
              img: 'https://dimg.dillards.com/is/image/DillardsZoom/mainProduct/birkenstock-womens-arizona-patent-birko-flor-slide-sandals/00000000_zi_f81f8ba2-a6c1-48d5-b21a-929ed1a94bee.jpg',
              attributes: {
                review_number: '5.00000',
                not_contains_girls: 'true',
                term: 'sandal',
                reviewrating: '8',
                decade: '066x',
                century: '06xx',
                new_arrival: 'false',
                dept: '0668',
                brand: 'birkenstock',
                pricerange: 'expensive',
                primary_category: 'shoes',
                can_ship_international: 'true',
                discount: null,
                product_class: 'tvq',
                on_sale: 'false',
              },
              id: 295863864002,
              title: 'Birkenstock Womens Arizona Patent Birko-Flor Slide Sandals',
              refCode: '20462109',
            },
            {
              prices: {
                USD: {
                  unitPrice: 118,
                  salePrice: 118,
                },
              },
              url: 'https://www.dillards.com/p/tommy-bahama-island-cays-tummy-control-colorblock-bandini-swim-top/512775273',
              img: 'https://dimg.dillards.com/is/image/DillardsZoom/mainProduct/tommy-bahama-island-cays-tummy-control-colorblock-bandini-swim-top/00000000_zi_0bfdbe81-5171-4245-9103-327bc261aa6c.jpg',
              attributes: {
                review_number: '4.68000',
                not_contains_girls: 'true',
                term: 'top',
                reviewrating: '22',
                decade: '019x',
                century: '01xx',
                new_arrival: 'false',
                dept: '0198',
                brand: 'tommy bahama',
                pricerange: 'expensive',
                primary_category: 'promotions',
                can_ship_international: 'true',
                discount: null,
                product_class: 'x34',
                on_sale: 'false',
              },
              id: 295863864052,
              title: 'Tommy Bahama Island Cays Tummy Control Color Block Bandini Swim Top',
              refCode: '20159637',
            },
            {
              prices: {
                USD: {
                  unitPrice: 59.99,
                  salePrice: 59.99,
                },
              },
              url: 'https://www.dillards.com/p/gianni-bini-betina-bling-embellished-thong-sandals/513861230',
              img: 'https://dimg.dillards.com/is/image/DillardsZoom/mainProduct/gianni-bini-betina-bling-embellished-thong-sandals/00000000_zi_69f07a83-19a1-4640-92ab-153b99032c46.jpg',
              attributes: {
                review_number: '4.60000',
                not_contains_girls: 'true',
                term: 'sandal',
                reviewrating: '143',
                decade: '067x',
                century: '06xx',
                new_arrival: 'false',
                dept: '0670',
                brand: 'gianni bini',
                pricerange: 'average',
                primary_category: 'shoes',
                can_ship_international: 'true',
                discount: null,
                product_class: 'tvp',
                on_sale: 'false',
              },
              id: 295863864102,
              title: 'Gianni Bini Betina Bling Embellished Thong Sandals',
              refCode: '20222589',
            },
            {
              prices: {
                USD: {
                  unitPrice: 70,
                  salePrice: 70,
                },
              },
              url: 'https://www.dillards.com/p/bogg-bag-small-bogg-tote-bag/510857310',
              img: 'https://dimg.dillards.com/is/image/DillardsZoom/mainProduct/bogg-bag-small-bogg-tote-bag/00000000_zi_01b34b07-b808-496f-a8f1-dae03ec9b949.jpg',
              attributes: {
                review_number: '4.89000',
                not_contains_girls: 'true',
                term: 'bag',
                reviewrating: '732',
                decade: '027x',
                century: '02xx',
                new_arrival: 'false',
                dept: '0271',
                brand: 'bogg bag',
                pricerange: 'average',
                primary_category: 'handbags',
                can_ship_international: 'true',
                discount: null,
                product_class: 'x81',
                on_sale: 'false',
              },
              id: 295863864152,
              title: 'Bogg Bag Baby Bogg Bag Tote',
              refCode: '20053291',
            },
            {
              prices: {
                USD: {
                  unitPrice: 98,
                  salePrice: 98,
                },
              },
              url: 'https://www.dillards.com/p/free-people-fp-movement-righteous-onsie/516112859',
              img: 'https://dimg.dillards.com/is/image/DillardsZoom/mainProduct/free-people-fp-movement-righteous-onsie/00000000_zi_fc39ca3c-6ab0-4f58-9015-83a4c1754878.jpg',
              attributes: {
                review_number: '4.43000',
                not_contains_girls: 'true',
                reviewrating: '7',
                decade: '018x',
                century: '01xx',
                new_arrival: 'false',
                dept: '0188',
                brand: 'free people',
                pricerange: 'average',
                primary_category: "women's clothing",
                can_ship_international: 'true',
                discount: null,
                product_class: 'qb1',
                on_sale: 'false',
              },
              id: 295863864202,
              title: 'Free People FP Movement Righteous Runsie One Piece Romper',
              refCode: '20352823',
            },
            {
              prices: {
                USD: {
                  unitPrice: 125,
                  salePrice: 125,
                },
              },
              url: 'https://www.dillards.com/p/born-sari-leather-cork-platform-wedge-sandals/515781777',
              img: 'https://dimg.dillards.com/is/image/DillardsZoom/mainProduct/born-sari-leather-cork-platform-wedge-sandals/00000000_zi_5478c1ca-e982-4f10-a785-e9e0ffac8229.jpg',
              attributes: {
                review_number: '4.78000',
                not_contains_girls: 'true',
                term: 'sandal',
                reviewrating: '118',
                decade: '065x',
                century: '06xx',
                new_arrival: 'false',
                dept: '0659',
                brand: 'born',
                pricerange: 'expensive',
                primary_category: 'shoes',
                can_ship_international: 'true',
                discount: null,
                product_class: 'srq',
                on_sale: 'false',
              },
              id: 295863864252,
              title: 'Born Sari Leather Cork Platform Sandals',
              refCode: '20337362',
            },
            {
              prices: {
                USD: {
                  unitPrice: 55,
                  salePrice: 55,
                },
              },
              url: 'https://www.dillards.com/p/polo-ralph-lauren-signature-standard-fit-short-sleeve-crew-neck-tee/512056805',
              img: 'https://dimg.dillards.com/is/image/DillardsZoom/mainProduct/polo-ralph-lauren-signature-standard-fit-short-sleeve-crew-neck-tee/00000000_zi_2d05c57e-71bf-4b4d-86d9-a44097517256.jpg',
              attributes: {
                review_number: '4.80000',
                not_contains_girls: 'true',
                term: 'jersey',
                reviewrating: '700',
                decade: '054x',
                century: '05xx',
                new_arrival: 'false',
                dept: '0545',
                brand: 'polo ralph lauren',
                pricerange: 'average',
                primary_category: 'men',
                can_ship_international: 'true',
                discount: null,
                product_class: '820|820',
                on_sale: 'false',
              },
              id: 295863864302,
              title: 'Polo Ralph Lauren Classic Fit Jersey Short Sleeve T-Shirt',
              refCode: '20120505',
            },
            {
              prices: {
                USD: {
                  unitPrice: 450,
                  salePrice: 450,
                },
              },
              url: 'https://www.dillards.com/p/nuna-rava-refined-convertible-car-seat/517988731',
              img: 'https://dimg.dillards.com/is/image/DillardsZoom/mainProduct/nuna-rava-refined-convertible-car-seat/00000001_zi_8e6dc98e-414f-49d6-8152-e7bc7e6927c7.jpg',
              attributes: {
                review_number: '4.76000',
                not_contains_girls: 'true',
                reviewrating: '25',
                decade: '041x',
                century: '04xx',
                new_arrival: 'false',
                dept: '0418',
                brand: 'nuna',
                pricerange: 'expensive',
                primary_category: 'kids',
                can_ship_international: 'true',
                discount: null,
                product_class: 'r1z',
                on_sale: 'false',
              },
              id: 295863864352,
              title: 'Nuna Rava Refined Secure Convertible Car Seat',
              refCode: '20441666',
            },
            {
              prices: {
                USD: {
                  unitPrice: 325,
                  salePrice: 325,
                },
              },
              url: 'https://www.dillards.com/p/nuna-pipa-rx-infant-car-seat--relx-base---black-edition/518439426',
              img: 'https://dimg.dillards.com/is/image/DillardsZoom/mainProduct/nuna-pipa-rx-infant-car-seat--relx-base---black-edition/00000000_zi_09d0cd3a-0898-4511-be8b-e5cf33e39053.jpg',
              attributes: {
                review_number: '5.00000',
                not_contains_girls: 'true',
                reviewrating: '4',
                decade: '041x',
                century: '04xx',
                new_arrival: 'false',
                dept: '0418',
                brand: 'nuna',
                pricerange: 'expensive',
                primary_category: 'kids',
                can_ship_international: 'true',
                discount: null,
                product_class: 'r1z',
                on_sale: 'false',
              },
              id: 295863864402,
              title: 'Nuna Pipa RX Infant Car Seat  Relx Base - Black Edition',
              refCode: '20479856',
            },
            {
              prices: {
                USD: {
                  unitPrice: 79.5,
                  salePrice: 79.5,
                },
              },
              url: 'https://www.dillards.com/p/tommy-bahama-island-cays-colorblock-hipster-swim-bottom/512775268',
              img: 'https://dimg.dillards.com/is/image/DillardsZoom/mainProduct/tommy-bahama-island-cays-colorblock-hipster-swim-bottom/00000000_zi_5eeb35a9-398a-4017-b3ab-6fc8f721f0f8.jpg',
              attributes: {
                review_number: '4.93000',
                not_contains_girls: 'true',
                reviewrating: '14',
                decade: '019x',
                century: '01xx',
                new_arrival: 'false',
                dept: '0198',
                brand: 'tommy bahama',
                pricerange: 'average',
                primary_category: 'promotions',
                can_ship_international: 'true',
                discount: null,
                product_class: 'wh4',
                on_sale: 'false',
              },
              id: 295863864452,
              title: 'Tommy Bahama Island Cays Color Block Hipster Swim Bottom',
              refCode: '20159638',
            },
            {
              prices: {
                USD: {
                  unitPrice: 99,
                  salePrice: 99,
                },
              },
              url: 'https://www.dillards.com/p/kurt-geiger-london-meena-eagle-head-ornament-flat-slides/512481252',
              img: 'https://dimg.dillards.com/is/image/DillardsZoom/mainProduct/kurt-geiger-london-meena-eagle-head-ornament-flat-slides/00000000_zi_42a99141-03a1-4348-841d-029008e3828d.jpg',
              attributes: {
                review_number: '4.79000',
                not_contains_girls: 'true',
                term: 'sandal',
                reviewrating: '103',
                decade: '064x',
                century: '06xx',
                new_arrival: 'false',
                dept: '0646',
                brand: 'kurt geiger london',
                pricerange: 'average',
                primary_category: 'shoes',
                can_ship_international: 'true',
                discount: null,
                product_class: 'tvq',
                on_sale: 'false',
              },
              id: 295863864502,
              title: 'Kurt Geiger London Meena Quilted Eagle Head Sandals',
              refCode: '20144165',
            },
            {
              prices: {
                USD: {
                  unitPrice: 49.95,
                  salePrice: 49.95,
                },
              },
              url: 'https://www.dillards.com/p/birkenstock-arizona-waterproof-essentials-slide-sandals/507810851',
              img: 'https://dimg.dillards.com/is/image/DillardsZoom/mainProduct/birkenstock-arizona-waterproof-essentials-slide-sandals/00000000_zi_1716bc44-517c-4217-af14-e0e9293371f7.jpg',
              attributes: {
                review_number: '4.67000',
                not_contains_girls: 'true',
                term: 'sandal',
                reviewrating: '497',
                decade: '066x',
                century: '06xx',
                new_arrival: 'false',
                dept: '0668',
                brand: 'birkenstock',
                pricerange: 'average',
                primary_category: 'shoes',
                can_ship_international: 'true',
                discount: null,
                product_class: 'tvq',
                on_sale: 'false',
              },
              id: 295863864552,
              title: 'Birkenstock Womens Arizona EVA Waterproof Essentials Pool Slide Sandals',
              refCode: '05295199',
            },
            {
              prices: {
                USD: {
                  unitPrice: 99,
                  salePrice: 99,
                },
              },
              url: 'https://www.dillards.com/p/kurt-geiger-london-meena-quilted-metallic-multi-color-pool-slides/516147219',
              img: 'https://dimg.dillards.com/is/image/DillardsZoom/mainProduct/kurt-geiger-london-meena-quilted-metallic-multi-color-pool-slides/00000000_zi_bbbdb0c7-af01-4b1b-8c30-d79f0a89c648.jpg',
              attributes: {
                review_number: '4.61000',
                not_contains_girls: 'true',
                reviewrating: '49',
                decade: '064x',
                century: '06xx',
                new_arrival: 'false',
                dept: '0646',
                brand: 'kurt geiger london',
                pricerange: 'average',
                primary_category: 'shoes',
                can_ship_international: 'true',
                discount: null,
                product_class: 'tvq',
                on_sale: 'false',
              },
              id: 295863864602,
              title: 'Kurt Geiger London Meena Metallic Rainbow Pool Slides',
              refCode: '20354412',
            },
            {
              prices: {
                USD: {
                  unitPrice: 49.5,
                  salePrice: 49.5,
                },
              },
              url: 'https://www.dillards.com/p/polo-ralph-lauren-classic-cotton-chino-sports-cap/501132073',
              img: 'https://dimg.dillards.com/is/image/DillardsZoom/mainProduct/polo-ralph-lauren-classic-cotton-chino-sports-cap/00000000_zi_0b7af760-7471-4661-8f76-cbf8ac7d3dfd.jpg',
              attributes: {
                review_number: '4.70000',
                not_contains_girls: 'true',
                term: 'cap',
                reviewrating: '429',
                decade: '054x',
                century: '05xx',
                new_arrival: 'false',
                dept: '0545',
                brand: 'polo ralph lauren',
                pricerange: 'average',
                primary_category: 'men',
                can_ship_international: 'true',
                discount: null,
                contains_cap: 'true',
                product_class: '230|230',
                on_sale: 'false',
              },
              id: 295863864652,
              title: 'Polo Ralph Lauren Classic Cotton Chino Sports Cap',
              refCode: '02743048',
            },
          ],
        },
      ];
    }
  }

  mapArrayToObject(stringArrayProducts) {
    var namedObjectProducts = [];
    for (var i = 0; i < stringArrayProducts.length; i++) {
      namedObjectProducts.push({
        productName: stringArrayProducts[i][0],
        productUrl: stringArrayProducts[i][1],
        productImg: `https://dimg.dillards.com/is/image/DillardsZoom/${this.props.productImageTemplate ? this.props.productImageTemplate : 'productRec'}/${stringArrayProducts[i][13]}/${stringArrayProducts[i][2].split('dimg').length > -1 ? stringArrayProducts[i][2].split('/')[stringArrayProducts[i][2].split('/').length - 1].split('.jpg').join('') : stringArrayProducts[i][2]}.jpg`,
        shipInternational: stringArrayProducts[i][8],
        productCatentryId: stringArrayProducts[i][9],
        productBrandName: stringArrayProducts[i][12],
        keyword: stringArrayProducts[i][13],
        recInteractionData: stringArrayProducts[i][14],
      });
    }
    return namedObjectProducts;
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (this.props.contentData && this.props.contentData.productId != nextProps.contentData.productId) {
      return true;
    }
    if (!_.isEqual(nextState, this.state)) {
      return true;
    }
    return false;
  }

  removeRecentlyViewedProduct(catentryIdToRemove) {
    //update localstorage with new array
    var recentlyViewedProducts = [];
    try {
      recentlyViewedProducts = JSON.parse(localStorage.getItem('recentlyViewed') || '[]');
    } catch (e) {
      console.log(e);
    }
    for (var i = 0; i < recentlyViewedProducts.length; i++) {
      var existingRecentlyViewedProduct = recentlyViewedProducts[i];
      if (existingRecentlyViewedProduct[9] == catentryIdToRemove) {
        recentlyViewedProducts.splice(i, 1);
        localStorage.setItem('recentlyViewed', JSON.stringify(recentlyViewedProducts));
        break;
      }
    }

    //force react to rerender with new list
    this.setState({
      rec_attributes: this.state.rec_attributes.filter((e) => e.productCatentryId != catentryIdToRemove),
    });
  }

  forceRenderRecentlyViewed() {
    var recentlyViewedProducts = [];
    try {
      recentlyViewedProducts = JSON.parse(localStorage.getItem('recentlyViewed') || []);
      for (var i = 0; i < recentlyViewedProducts.length; i++) {
        if (
          this.props.contentData &&
          this.props.contentData.productId &&
          recentlyViewedProducts[i][9] == this.props.contentData.productId
        )
          recentlyViewedProducts.splice(i, 1);
      }
    } catch (e) {
      localStorage.removeItem('recentlyViewed');
    }
    this.forceRerender(this.mapArrayToObject(recentlyViewedProducts));
  }

  forceRenderSolrData(category, brand, newArrival, imageTemplate) {
    let personalizationUrl = '/data/personalizedProducts?';
    personalizationUrl += category ? `superCatId=${category}&` : '';
    if (brand) {
      brand = encodeURIComponent(brand.split('®').join('%C2%AE')).split('%2B').join('%252B');
    }
    personalizationUrl += brand ? `mfName=${brand}&` : '';
    personalizationUrl += newArrival ? `orderBy=6&newArrivals=true&` : `orderBy=1&newArrivals=false&`;
    personalizationUrl += `productImageTemplate=${imageTemplate}`;
    try {
      var axiosOptions = {
        method: 'get',
        url: personalizationUrl,
      };
      axios(axiosOptions).then((ajaxResponse) => {
        if (!this.state.didUnmount) {
          var responseJSON = {};
          try {
            responseJSON =
              typeof ajaxResponse.data.contentData == 'object'
                ? ajaxResponse.data.contentData
                : JSON.parse(ajaxResponse.data.contentData);
          } catch (e) {}
          this.forceRerender(this.mapArrayToObject(responseJSON.products));
        }
      });
    } catch (e) {
      console.log(e);
    }
  }

  getAIRecs = () => {
    let aiProductRecs = [];
    try {
      let recentlyViewedProducts = JSON.parse(localStorage.getItem('recentlyViewed') || []);
      let catEntryIdList = [];
      recentlyViewedProducts.forEach((product) => catEntryIdList.push(product[9]));

      if (catEntryIdList) {
        var axiosConfig = {
          method: 'post',
          url: '/AIRecommendations/productRecs/topRecsForProductList',
          credentials: 'omit',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          data: catEntryIdList,
        };

        axios(axiosConfig).then((response) => {
          if (response.data?.response?.productRecDetails?.length > 0) {
            response.data.response.productRecDetails.forEach((product) => {
              let formattedProductObj = {};
              formattedProductObj.productName = product.name;
              formattedProductObj.productUrl = product.url;
              formattedProductObj.productImg = product.imgUrl;
              formattedProductObj.productCatentryId = product.catentryId;
              formattedProductObj.partNumber = product.partNumber;
              formattedProductObj.productBrandName = product.brandName;
              formattedProductObj.rating = product.rating;
              formattedProductObj.reviewCount = product.reviewCount;
              formattedProductObj.offerPriceMin = product.offerPriceMin;
              formattedProductObj.offerPriceMax = product.offerPriceMax;
              formattedProductObj.onSpecial = product.onSale;
              formattedProductObj.isInternational = product.isInternational;
              aiProductRecs.push(formattedProductObj);
            });
            this.forceRerender(aiProductRecs);
          }
        });
      }
    } catch (e) {}
  };

  forceRerender(products) {
    if (!this.state.didUnmount) {
      this.setState({ rec_attributes: products });
    }
  }

  componentDidMount() {
    //if we are coming from product recs then pull the rec_attributes array from local storage
    //instead of calling IBM and waiting for them to pass us the rec_attributes
    this.state.didUnmount = false;
    if (this.props.zone == 'RecentlyViewed' && window.Modernizr && Modernizr.localstorage) {
      $(window).on('recentlyViewedUpdate', this.forceRenderRecentlyViewed);
      this.state.zone = 'RecentlyViewed';
      this.forceRenderRecentlyViewed();
    } else if (this.props.zone == 'LastViewedAI' && window.Modernizr && Modernizr.localstorage) {
      $(window).on('recentlyViewedUpdate', this.getAIRecs);
      this.state.zone = 'LastViewedAI';
      this.getAIRecs();
    } else if (this.props.zone == 'SuperCatNewArrivals') {
      this.state.zone = 'SuperCatNewArrivals';
      if (this.props.superCat)
        this.forceRenderSolrData(this.props.superCat, undefined, true, this.props.productImageTemplate);
    } else if (this.props.zone == 'BrandSuperCatNewArrivals') {
      this.state.zone = 'BrandSuperCatNewArrivals';
      if (this.props.superCat || this.props.mfName)
        this.forceRenderSolrData(this.props.superCat, this.props.mfName, true, this.props.productImageTemplate);
    } else if (this.props.zone == 'BrandSuperCatPopular') {
      this.state.zone = 'BrandSuperCatPopular';
      if (this.props.superCat || this.props.mfName)
        this.forceRenderSolrData(this.props.superCat, this.props.mfName, false, this.props.productImageTemplate);
      else this.forceRenderSolrData('425', undefined, false, this.props.productImageTemplate);
    } else if (this.props.zone == 'TopSellerSuperCats') {
      this.forceRerender(this.mapArrayToObject(this.props.products));
    } else {
      $(window).on('showRecs', this.showRecs);
      this.setRecRequestData(
        this.props.zoneName || this.props.zone,
        this.props.zoneModifier || this.props.categoryId || '',
        this.props.attribute || ''
      );
      this.props.getRecAttributes((this.state.rec_attributes || []).length);
    }
  }
  componentDidUpdate() {
    this.props.getRecAttributes((this.state.rec_attributes || []).length);
  }

  showRecs() {
    //triggered from adobe launch rule
    this.formatRecContent(this.props.zoneName || this.props.zone);
  }

  setRecRequestData(zone, categoryId, brand) {
    if (
      this.props.passedAppFunctions.wasParms.useProductRecommendations == 'true' &&
      this.props.passedAppFunctions.wasParms.adobeRecsOffByZone?.indexOf(zone) == -1
    ) {
      try {
        var partNumber = this.props.productId || null;
        var url = window.location.href.split('?')[0];
        var topPersonalizationInfo = getTopPersonalizationInfo('ALL', this.props.passedAppFunctions.wasParms);

        //setting all rec data into a window scoped variable for adobe sdk migration
        window.recCallData = window.recCallData ? window.recCallData : [];
        if (recCallData.length > 0) {
          if (recCallData[0].url != url) {
            window.recCallData = [];
            recCallData.push({ url: url });
          }
        } else {
          recCallData.push({ url: url });
        }

        var thisData = {};
        thisData.zone = zone;
        thisData.category = categoryId;
        thisData.brand = brand;
        thisData.partNumber = partNumber;
        thisData.url = url;
        thisData.productClass =
          this.props.contentData && this.props.contentData.dceProductClass
            ? this.props.contentData.dceProductClass
            : '';
        thisData.mic = this.props.contentData && this.props.contentData.mic ? this.props.contentData.mic : '';
        thisData.dept = this.props.contentData && this.props.contentData.dept ? this.props.contentData.dept : '';
        thisData.decade =
          this.props.contentData && this.props.contentData.dept
            ? this.props.contentData.dept.slice(0, this.props.contentData.dept.length - 1) + 'X'
            : '';
        thisData.century =
          this.props.contentData && this.props.contentData.dept
            ? this.props.contentData.dept.slice(0, this.props.contentData.dept.length - 2) + 'XX'
            : '';
        thisData.group =
          this.props.contentData && this.props.contentData.dceGroup ? this.props.contentData.dceGroup : '';
        thisData.name =
          this.props.contentData && this.props.contentData.productName ? this.props.contentData.productName : '';
        thisData.newArrival =
          this.props.contentData && this.props.contentData.newArrival ? this.props.contentData.newArrival : '';
        thisData.favoriteBrand =
          topPersonalizationInfo && topPersonalizationInfo.favoriteBrand ? topPersonalizationInfo.favoriteBrand : '';
        thisData.favoriteCategoryId =
          topPersonalizationInfo && topPersonalizationInfo.favoriteSuperCat
            ? topPersonalizationInfo.favoriteSuperCat
            : '';
        thisData.includeWithRecData = true;
        recCallData.push({ HorizontalRecommendation: thisData });
      } catch (e) {
        if (
          this.props.passedAppFunctions.wasParms.adobeRecsDebug &&
          this.props.passedAppFunctions.wasParms.adobeRecsDebug == 'true'
        )
          console.log(e);
      }
    }
  }

  formatRecContent(zone) {
    try {
      if (window.location.host === 'localhost') this.setOptiRecs(zone);
      if (window.optiSmartRecs) {
        for (var i = 0; i < window.optiSmartRecs.length; i++) {
          var thisContent = window.optiSmartRecs[i];
          if (thisContent.widget === zone) {
            // var recInteractionData = {};
            // if(thisContent &&
            //    thisContent.rawData &&
            //    thisContent.rawData.id &&
            //    thisContent.rawData.scope &&
            //    thisContent.rawData.scopeDetails){
            // 		recInteractionData.recId = thisContent.rawData.id;
            // 		recInteractionData.recZone = thisContent.rawData.scope;
            // 		recInteractionData.recScopeDetails = thisContent.rawData.scopeDetails;
            // }
            var responseData = thisContent;
            var rec_attributes = [];
            var recRequestIds = [];
            // if(this.props.passedAppFunctions.wasParms.adobeRecsDebug && this.props.passedAppFunctions.wasParms.adobeRecsDebug == 'true') console.log(responseData.recommendedItems);

            for (var key in responseData.recs) {
              var thisRec = responseData.recs[key];
              var attrs = [
                thisRec.title,
                thisRec.url.indexOf('dillards.com') > -1 ? thisRec.url.split('dillards.com')[1] : '',
                thisRec.img.indexOf('/') > -1
                  ? thisRec.img.split('/')[thisRec.img.split('/').length - 1].split('.jpg').join('')
                  : '',
                thisRec.reviewRating ? thisRec.reviewRating : 0.0,
                '', //brand code
                thisRec.reviewNumber ? thisRec.reviewNumber : '',
                '', //minPrice
                thisRec.prices.USD.unitPrice ? thisRec.prices.USD.unitPrice : '',
                'true', //shipInternational
                thisRec.url.indexOf('/') > -1 ? thisRec.url.split('/')[thisRec.url.split('/').length - 1] : '',
                thisRec.dpt ? thisRec.dpt : '',
                thisRec.mic ? thisRec.mic : '',
                thisRec.attributes.brand
                  ? thisRec.attributes.brand
                      .split(' ')
                      .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
                      .join(' ')
                  : '',
                thisRec.url.indexOf('dillards.com') > -1 ? thisRec.url.split('/')[4] : '',
                thisRec.id ? thisRec.id : '',
              ];
              if (
                attrs[0].indexOf('$entity') == -1 &&
                attrs[1].length > 0 &&
                attrs[2].length > 0 &&
                attrs[9].length > 0 &&
                attrs[12].length > 0 &&
                attrs[13].length > 0
              ) {
                rec_attributes.push(attrs);
                recRequestIds.push(thisRec.id);
              }
            }
            this.setRecState(
              'rec_product_ids',
              zone,
              'symbolic',
              'target_id',
              'target_category',
              rec_attributes,
              'target_attributes',
              'target_header_txt',
              'ab_test_id',
              'rec_category_ids'
            );
            responseData.recs.splice(i, 1);
          }
        }
        if (recRequestIds) {
          const listOfIds = 'ids=' + recRequestIds.join(',');
          const optiEnv = window.location.host === 'www.dillards.com' ? 'dillardprod' : 'dillardprep';
          Peerius?.sendAjax(optiEnv + '/rec/shown.pagex?' + listOfIds);
        }
      }
    } catch (er) {
      if (
        this.props.passedAppFunctions.wasParms.adobeRecsDebug &&
        this.props.passedAppFunctions.wasParms.adobeRecsDebug == 'true'
      )
        console.log(er);
    }
  }

  componentWillUnmount() {
    //remove the window scoped function so it doesnt cause a console error
    //just to clean up logs and noop function calls.
    window[
      `${
        (this.props.zoneName || this.props.zone,
        this.props.zoneModifier || this.props.categoryId || '',
        this.props.topBrand || this.props.attribute || '')
      }_zp`
    ] = function () {};
    $(window).off('recentlyViewedUpdate', this.forceRerender);
    $(window).off('showRecs', this.showRecs);
    this.state.didUnmount = true;
  }

  render() {
    if (this.props.passedAppFunctions.wasParms.useProductRecommendations !== 'true') return null;
    return (
      <ProductCarousel
        productsPerRow={this.props.productsPerRow}
        rows={this.props.rows}
        scrollable={this.props.scrollable}
        title={this.props.title}
        showProductTitle={this.props.showProductTitle}
        showProductPrice={false}
        showProductRating={false}
        cmsp={this.props.cmsp}
        products={this.state.rec_attributes}
        passedAppFunctions={this.props.passedAppFunctions}
        contentData={this.props.contentData}
        zone={this.props.zoneName || this.props.zone}
        removeRecentlyViewedProduct={this.removeRecentlyViewedProduct}
      />
    );
  }
}

export default HorizontalRecommendation;
